export enum Size {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  xxl = 'xxl',
  block = 'block',
}

export const SizeValues = Object.values(Size)
export type SizeArray = typeof SizeValues
export type TypeSize = SizeArray[number]
